import { TreatmentTarget } from "../treatments/treatment_target";

export class PlainTextTreatment extends TreatmentTarget {
  constructor() {
    super();
  }

  validate() {
    let response = {}
    this.querySelectorAll('textarea').forEach((input) => { 
      input.classList.remove("error")
      if(!input.value.trim()) {
        input.classList.add("error")
        response.requiredMissing = true 
      }
    });
    return response;
  }

  getData() {
    return {value: this.querySelector('.plain_text_input').value, type: PlainTextTreatment.getType()};
  }

  getIcon() {
    return 'fa-align-left'
  }

  isTarget() {
    return false;
  }

  static getType() {
    return "TEXT"
  }

  connectedCallback() {
    this.innerHTML =
      `
      <style>
        .plain_text_container {
          position: relative;
        }

        #plain-text-remaining {
          position: absolute;
          bottom: 10px;
          right: 10px;
        }
      </style>
      <div class="col-sm-12 ct_action" data-action_type=PLAIN_TEXT>
        <div class="panel panel-default">
            <h4>Plain Text</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
            <div class="form-group plain_text_container">
              <textarea class="form-control plain_text_input" placeholder="Message to consumer" maxlength="160">${this.message ? this.message.text : ''}</textarea>
              <div id="plain-text-remaining">0/160</div>
            </div>
        </div>
      </div>
      <div class="col-sm-12 ct_line">
        <div class="ct_vertical_arrow"></div>
        <div class="option_text">Message sent</div>
        <div class="ct_vertical_arrow">
          <div class=arrow-down></div>
        </div>
      </div>
      `;
    super.connectedCallback();

    this.querySelector('.plain_text_input').addEventListener('keyup', function() {
      this.textRemaining();
    }.bind(this));
  }

  textRemaining() {
    let remaining = this.querySelector('.plain_text_input').value.length;
    if (remaining <= 160) {
      this.querySelector('#plain-text-remaining').innerHTML = `${remaining}/160`;
    }
  }
}

customElements.define('plain-text-treatment', PlainTextTreatment)